export const ANDROID_STORE_URL =
  process.env.REACT_APP_ANDROID_STORE_URL ||
  "https://play.google.com/store/apps/details?id=com.mondowy_app_user";

export const IOS_STORE_URL =
  process.env.REACT_APP_IOS_STORE_URL ||
  "https://apps.apple.com/us/app/mondoway/id6444758076";

export const BUSINESS_ANDROID_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.mondowy_app_bussniss&pcampaignid=web_share";

export function getPartnerSignInUrl() {
  return process.env.NODE_ENV === "production"
    ? "https://partner.mondoway.com/sign-in"
    : "https://partner.dev.mondoway.com/sign-in";
}

export const STORE_FALLBACK_MS = 1800;

const PUBLIC_ID_PATTERN = /^[A-Za-z0-9][A-Za-z0-9_-]{0,127}$/;
const PROFILE_HANDLE_PATTERN = /^[A-Za-z0-9._]{1,30}$/;

const DEEP_LINK_BUILDERS = {
  ad: (id) => `mondoway-user://ad/${encodeURIComponent(id)}`,
  reel: (id) => `mondoway-user://social/reel/${encodeURIComponent(id)}`,
  post: (id) => `mondoway-user://social/post/${encodeURIComponent(id)}`,
  story: (id) => `mondoway-user://social/story/${encodeURIComponent(id)}`,
  profile: (handle) =>
    `mondoway-user://social/profile/${encodeURIComponent(handle)}`
};

const DEEP_LINK_VALUE_PATTERNS = {
  ad: PUBLIC_ID_PATTERN,
  reel: PUBLIC_ID_PATTERN,
  post: PUBLIC_ID_PATTERN,
  story: PUBLIC_ID_PATTERN,
  profile: PROFILE_HANDLE_PATTERN
};

export function getDeviceType(browserNavigator = window.navigator) {
  const userAgent =
    browserNavigator.userAgent || browserNavigator.vendor || window.opera || "";
  const isAndroid = /android/i.test(userAgent);
  const isIOS =
    /iPad|iPhone|iPod/.test(userAgent) ||
    (browserNavigator.platform === "MacIntel" &&
      browserNavigator.maxTouchPoints > 1);

  if (isAndroid) {
    return "android";
  }

  if (isIOS) {
    return "ios";
  }

  return "other";
}

export function decodeAndValidatePublicId(routeParam) {
  if (typeof routeParam !== "string" || routeParam.length === 0) {
    return null;
  }

  try {
    const decodedId = decodeURIComponent(routeParam);
    return PUBLIC_ID_PATTERN.test(decodedId) ? decodedId : null;
  } catch (error) {
    return null;
  }
}

export function decodeAndValidateProfileHandle(routeParam) {
  if (typeof routeParam !== "string" || routeParam.length === 0) {
    return null;
  }

  try {
    const decodedHandle = decodeURIComponent(routeParam);
    return PROFILE_HANDLE_PATTERN.test(decodedHandle) ? decodedHandle : null;
  } catch (error) {
    return null;
  }
}

export function validatePublicId(value) {
  return typeof value === "string" && PUBLIC_ID_PATTERN.test(value)
    ? value
    : null;
}

export function validateProfileHandle(value) {
  return typeof value === "string" && PROFILE_HANDLE_PATTERN.test(value)
    ? value
    : null;
}

export function buildDeepLink(type, value) {
  const builder = DEEP_LINK_BUILDERS[type];
  const pattern = DEEP_LINK_VALUE_PATTERNS[type];

  if (!builder || !pattern || !pattern.test(value)) {
    return null;
  }

  return builder(value);
}

export function getStoreUrl(deviceType) {
  if (deviceType === "ios") {
    return IOS_STORE_URL;
  }

  if (deviceType === "android") {
    return ANDROID_STORE_URL;
  }

  return null;
}
